import { render, staticRenderFns } from "./oldPagination.vue?vue&type=template&id=423ef8e2&scoped=true&"
import script from "./oldPagination.vue?vue&type=script&lang=js&"
export * from "./oldPagination.vue?vue&type=script&lang=js&"
import style0 from "./oldPagination.vue?vue&type=style&index=0&id=423ef8e2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423ef8e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('423ef8e2')) {
      api.createRecord('423ef8e2', component.options)
    } else {
      api.reload('423ef8e2', component.options)
    }
    module.hot.accept("./oldPagination.vue?vue&type=template&id=423ef8e2&scoped=true&", function () {
      api.rerender('423ef8e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ui/oldPagination/oldPagination.vue"
export default component.exports